module.exports = __webpack_public_path__ + "assets/092fa30f9493e8977c2269c8df4d53bd.png";